import React, { useState, Fragment, useEffect } from 'react'
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider
} from '@material-ui/core'
import {
  Receipt as ReciptIcon,
  AssignmentInd as AssignmentIndIcon,
  People as PeopleIcon,
  BarChart as BarChartIcon,
  Settings as SettingsIcon,
  Fastfood as FastfoodIcon,
  Layers as LayersIcon,
  Info as InfoIcon,
  CardGiftcard as CardGiftcardIcon,
  MobileFriendly as MobileFriendlyIcon,
  Motorcycle as MotorcycleIcon,
  LocalAtm as LocalAtmIcon,
  SwapHorizontalCircle as SwapHorizontalCircleIcon,
  Home as HomeIcon,
  Gavel as GavelIcon,
  EditLocation as EditLocationIcon,
  PhonelinkRing as PhonelinkRingIcon,
  Widgets as WidgetsIcon,
  Public as PublicIcon
} from '@material-ui/icons'
import User from '../../containers/userContainer'
import { loginWithGoogle } from '../../firebase/login'
import { Link } from '@reach/router'
import Avatar from '@material-ui/core/Avatar'
import { makeStyles } from '@material-ui/core/styles'
import Context from '../../context/mainContext'
import googleLogo from '../../img/Google.png'
import Notification from '../notification'
import useMainContext from '../../hooks/useMainContext'


const useStyles = makeStyles({
  avatar: {
    width: 32,
    height: 32,
  },
  link: {
    textDecoration: 'none',
    color: '#000'
  },
  listItemIcon: {
    minWidth: 40
  },
  appVersion: {
    fontSize: 12,
  }
})

export const MainListItems = ({ setOpen = () => { } }) => {
  const classes = useStyles()
  const { modules } = useMainContext()
  return (
    <div>
      <Link to='/orders' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <ReciptIcon />
          </ListItemIcon>
          <ListItemText primary="Pedidos" />
        </ListItem>
      </Link>
      {
        modules?.orderAssignmentByAdmin &&
        <Link to='/orderAssignment' className={classes.link} onClick={() => setOpen(false)}>
          <ListItem button>
            <ListItemIcon className={classes.listItemIcon}>
              <MobileFriendlyIcon />
            </ListItemIcon>
            <ListItemText primary="Asignar pedidos" />
          </ListItem>
        </Link>
      }
      {
        modules?.tables &&
        <Link to='/tables' className={classes.link} onClick={() => setOpen(false)}>
          <ListItem button>
            <ListItemIcon className={classes.listItemIcon}>
              <WidgetsIcon />
            </ListItemIcon>
            <ListItemText primary="Mesas" />
          </ListItem>
        </Link>
      }
      {
        modules?.beepers &&
        <Link to='/beepers' className={classes.link} onClick={() => setOpen(false)}>
          <ListItem button>
            <ListItemIcon className={classes.listItemIcon}>
              <PhonelinkRingIcon />
            </ListItemIcon>
            <ListItemText primary="Beepers" />
          </ListItem>
        </Link>
      }

      <Link to='/products' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <FastfoodIcon />
          </ListItemIcon>
          <ListItemText primary="Productos" />
        </ListItem>
      </Link>
      <Link to='/clients' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText primary="Clientes" />
        </ListItem>
      </Link>
      <Link to='/staff' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <AssignmentIndIcon />
          </ListItemIcon>
          <ListItemText primary="Personal" />
        </ListItem>
      </Link>
      <Link to='/zones' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <LayersIcon />
          </ListItemIcon>
          <ListItemText primary="Zonas" />
        </ListItem>
      </Link>
      <Link to='/map' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <PublicIcon />
          </ListItemIcon>
          <ListItemText primary="Mapa" />
        </ListItem>
      </Link>
      <Link to='/gifts' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <CardGiftcardIcon />
          </ListItemIcon>
          <ListItemText primary="Sorteos" />
        </ListItem>
      </Link>
      <Link to='/deliveries' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <MotorcycleIcon />
          </ListItemIcon>
          <ListItemText primary="Repartidores" />
        </ListItem>
      </Link>
      <Link to='/cashRegister' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <LocalAtmIcon />
          </ListItemIcon>
          <ListItemText primary="Caja" />
        </ListItem>
      </Link>
      <Link to='/stock' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <SwapHorizontalCircleIcon />
          </ListItemIcon>
          <ListItemText primary="Stock" />
        </ListItem>
      </Link>
    </div>
  )
}

export const SecondaryListItems = ({ setOpen = () => { } }) => {
  const { user } = useMainContext()
  const classes = useStyles()
  return (
    <div>
      {/* <ListSubheader inset>Saved reports</ListSubheader> */}
      {/* <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Stock" />
      </ListItem> */}
      {
        user?.permissions?.includes('reports') &&
        <Link to='/reports' className={classes.link} onClick={() => setOpen(false)}>
          <ListItem button>
            <ListItemIcon className={classes.listItemIcon}>
              <BarChartIcon />
            </ListItemIcon>
            <ListItemText primary="Reportes" />
          </ListItem>
        </Link>
      }

      <Link to='/config' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Configuraciones" />
        </ListItem>
      </Link>
      <Link to='/businessInfo' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <InfoIcon />
          </ListItemIcon>
          <ListItemText primary="Empresa" />
        </ListItem>
      </Link>
    </div>
  )
}

let loginCount = 0

export const UserItem = ({ setOpen = () => { } }) => {
  const classes = useStyles()
  const [notificationOpen, setNotificationOpen] = useState(false)


  const handleLoginWithGoogle = () => {
    setOpen(false)

    //verifico si se está iniciando desde un navegador no compatible con google
    // por el momento no funciona por eso se comenta
    // if (!isGoogleProviderSupported()) {
    //   return setBrowserNoCompatible(true)
    // }

    loginWithGoogle()
      .then(() => {
        loginCount = 0
      })
      .catch(error => {
        console.error('error with google login:', error)
        //saveError(error)
        if (error.code === 'auth/network-request-failed') {
          if (loginCount < 6) {
            loginCount++
            return handleLoginWithGoogle()
          }
        } else {
          setNotificationOpen(true)
          loginCount = 0
        }
      })
  }

  return (
    <Fragment>
      <Notification notificationOpen={notificationOpen} handleNotificationClose={() => setNotificationOpen(false)} severity='error' notificationMessage='No se pudo iniciar sesión con google' />
      <Context.Consumer>
        {
          ({ user }) => user ?
            <>
              <Divider />
              <Link to='/direcciones' className={classes.link} onClick={() => setOpen(false)}>
                <ListItem button>
                  <ListItemIcon className={classes.listItemIcon}>
                    <EditLocationIcon />
                  </ListItemIcon>
                  <ListItemText primary="Mis direcciones" />
                </ListItem>
              </Link>
              <Link to='/cuenta' className={classes.link} onClick={() => setOpen(false)}>
                <ListItem>
                  <ListItemIcon className={classes.listItemIcon}>
                    <Avatar alt={user.displayName} src={user.photoURL} className={classes.avatar} />
                  </ListItemIcon>
                  <ListItemText>
                    <User />
                  </ListItemText>
                </ListItem>
              </Link>
            </>
            :
            <ListItem button onClick={() => setOpen(false)}>
              <ListItemIcon onClick={handleLoginWithGoogle} className={classes.listItemIcon}>
                <Avatar alt={'Google'} src={googleLogo} className={classes.avatar} />
              </ListItemIcon>
              <ListItemText>
                <User />
              </ListItemText>
            </ListItem>
        }
      </Context.Consumer>
    </Fragment>
  )
}

export const PublicList = ({ setOpen = () => { } }) => {
  const classes = useStyles()
  const { isAuth } = useMainContext()
  return (
    <div>
      <Link to='/' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Inicio" />
        </ListItem>
      </Link>
      <Link to='/productos' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <FastfoodIcon />
          </ListItemIcon>
          <ListItemText primary="Menú" />
        </ListItem>
      </Link>
      {
        isAuth &&
        <Link to='/misPedidos' className={classes.link} onClick={() => setOpen(false)}>
          <ListItem button>
            <ListItemIcon className={classes.listItemIcon}>
              <ReciptIcon />
            </ListItemIcon>
            <ListItemText primary="Últimos pedidos" />
          </ListItem>
        </Link>
      }

      <Link to='/acerca' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <InfoIcon />
          </ListItemIcon>
          <ListItemText primary="Información" />
        </ListItem>
      </Link>
      <Link to='/termsConditions' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <GavelIcon />
          </ListItemIcon>
          <ListItemText primary="Términos y Condiciones" />
        </ListItem>
      </Link>
    </div>
  )
}

export const ChefList = ({ setOpen = () => { } }) => {
  const classes = useStyles()
  return (
    <div>
      <Link to='/orders' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <ReciptIcon />
          </ListItemIcon>
          <ListItemText primary="Pedidos" />
        </ListItem>
      </Link>
      <Link to='/map' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <LayersIcon />
          </ListItemIcon>
          <ListItemText primary="Mapa" onClick={() => setOpen(false)} />
        </ListItem>
      </Link>
      <Link to='/productos' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <FastfoodIcon />
          </ListItemIcon>
          <ListItemText primary="Menú" />
        </ListItem>
      </Link>
      <Link to='/stock' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <SwapHorizontalCircleIcon />
          </ListItemIcon>
          <ListItemText primary="Stock" />
        </ListItem>
      </Link>
    </div>
  )
}

export const DeliveryList = ({ setOpen = () => { } }) => {
  const classes = useStyles()
  const { modules } = useMainContext()
  // console.log('DeliveryList modules', modules)
  return (
    <div>
      <Link to='/orders' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon} >
            <ReciptIcon />
          </ListItemIcon>
          <ListItemText primary="Pedidos" />
        </ListItem>
      </Link>
      {
        modules?.orderAssignmentByDelivery &&
        <Link to='/orderAllocation' className={classes.link} onClick={() => setOpen(false)}>
          <ListItem button>
            <ListItemIcon className={classes.listItemIcon}>
              <MobileFriendlyIcon />
            </ListItemIcon>
            <ListItemText primary="Asignar pedidos" />
          </ListItem>
        </Link>
      }

      <Link to='/productos' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <FastfoodIcon />
          </ListItemIcon>
          <ListItemText primary="Menu" />
        </ListItem>
      </Link>
      <Link to='/acerca' className={classes.link} onClick={() => setOpen(false)}>
        <ListItem button>
          <ListItemIcon className={classes.listItemIcon}>
            <InfoIcon />
          </ListItemIcon>
          <ListItemText primary="Información" />
        </ListItem>
      </Link>
    </div>
  )
}

export const AppVersion = () => {
  const classes = useStyles()
  const [version, setVersion] = useState('')

  useEffect(() => {
    const metas = document.getElementsByTagName('meta')
    for (let i = 0; i < metas.length; i++) {
      if (metas[i].getAttribute('name') === 'build-version') {
        console.log('Burgerhouse Version: v', metas[i].getAttribute('build-version'))
        return setVersion(metas[i].getAttribute('build-version'))
      }
    }
  }, [])

  return (
    <Typography className={classes.appVersion} align="center" color="textSecondary">{`v${version}`}</Typography>
  )
}